import api from 'shopify-theme-api';

window.api = api;
